import type { ActionConfig } from '@/components/ActionBar';
import { useAddEventsToReportAction } from '@/hooks';
import { useQueryResultsStore } from '@/stores';

export function useQueryAddToReportAction(): ActionConfig {
    const events = useQueryResultsStore((state) => state.events);
    const selectedEventIds = useQueryResultsStore(
        (state) => state.selectedEventIds,
    );
    const exitSelectionMode = useQueryResultsStore(
        (state) => state.exitSelectionMode,
    );
    const lastQueryParams = useQueryResultsStore(
        (state) => state.lastQueryParams,
    );

    return useAddEventsToReportAction({
        events: events.map((scored) => ({
            event: scored.event,
            confidence: scored.confidence,
        })),
        selection: {
            selectedIds: selectedEventIds,
            exitMultiSelectMode: exitSelectionMode,
        },
        query: lastQueryParams?.text,
    });
}
